'use client';

import { useEffect } from 'react';
import { useRouter } from 'next/navigation';
import { useGetMeQuery } from '../../lib/features/auth/authApiSlice';

/**
 * Client-side fallback for the home page's server-side auth redirect.
 *
 * The API's auth cookies are `SameSite=Strict`, so browsers leave them off
 * cross-site navigations (Steam's OpenID return, links from Discord or a
 * search result). The server then can't tell a signed-in user from a new
 * visitor and renders the landing page. This asks the API (a same-origin
 * request, which does carry the cookies) and moves signed-in users into
 * the app. It is only rendered for cross-site arrivals without cookies.
 */
export default function SessionRedirect() {
  const router = useRouter();
  const { data } = useGetMeQuery();

  useEffect(() => {
    if (data?.user) {
      router.replace('/collection');
    }
  }, [data, router]);

  return null;
}
